"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionTitle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const collection_title_style_1 = __importDefault(require("./collection.title.style"));
class CollectionTitle extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, children, suffix } = this.props;
            return (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.root }, { children: [children, suffix && jsx_runtime_1.jsx("span", Object.assign({ className: classes.suffix }, { children: suffix }), void 0)] }), void 0));
        };
    }
}
exports.CollectionTitle = CollectionTitle;
CollectionTitle.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.string.isRequired,
    suffix: prop_types_1.default.node
};
CollectionTitle.defaultProps = {
    suffix: null
};
exports.default = react_jss_1.default(collection_title_style_1.default)(CollectionTitle);
//# sourceMappingURL=collection.title.js.map